import { useEffect } from 'react'
import { setCookie, deleteCookie } from 'cookies-next'
import { cookieKeys } from 'lib/consts/browserStorage'

export const useSetProfileIdCookie = (profileId: Maybe<string>) => {
  useEffect(() => {
    if (profileId) {
      setCookie(cookieKeys.profileId, profileId)
    } else {
      deleteCookie(cookieKeys.profileId)
    }
  }, [profileId])
}
